import { useLocation } from '@tanstack/react-router'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

export default function PageTracker() {
  const { pathname } = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      $pathname: pathname,
    })
  }, [pathname])

  return null
}
